import { TabBar } from '@bp/ui-components';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Page } from '../../../../components/Page/Page';
import { DeputatePersonsTable } from '../../../../components/Persons/Tables/DeputatePersonsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { PersonRole } from '../../../../types/planung-graphql-client-defs';

export const SetupPersons = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  const [searchParams, setSearchParams] = useSearchParams();
  const personUuid = searchParams.get('personUuid') ?? undefined;

  const clearPersonUuid = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete('personUuid');
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <TabBar
        variant={'large'}
        tabs={[
          {
            trigger: t('persons.title', { count: 2 }),
            id: 'teachers',
            content: (
              <DeputatePersonsTable
                personsRole={PersonRole.Teacher}
                openPersonUuid={personUuid}
                onPersonOpened={clearPersonUuid}
              />
            ),
          },
          {
            trigger: t('persons.other'),
            id: 'other',
            content: <DeputatePersonsTable personsRole={PersonRole.Other} />,
          },
        ]}
      />
    </Page>
  );
};
